/**
 * @description 流量币模块路由
 * @note 原生默认 isHiddenNav: false；H5 fs-nav-bar 仅浏览器环境展示（见 mixins/h5Nav.js）
 */

export const trafficCoinRouter = [
  {
    path: '/trafficCoin/guide',
    name: 'trafficCoinGuide',
    component: () => import('views/trafficCoin/guide/index.vue'),
    meta: {
      title: '流量币'
    }
  },
  {
    path: '/trafficCoin/signup',
    name: 'trafficCoinSignup',
    component: () => import('views/trafficCoin/signup/index.vue'),
    meta: {
      title: '活动报名'
    }
  },
  {
    path: '/trafficCoin/storeIdGuide',
    name: 'trafficCoinStoreIdGuide',
    component: () => import('views/trafficCoin/storeIdGuide/index.vue'),
    meta: {
      title: '如何获取闪购门店ID'
    }
  }
]
